import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
export var HeadingLevel;
(function (HeadingLevel) {
    HeadingLevel["H1"] = "h1";
    HeadingLevel["H2"] = "h2";
    HeadingLevel["H3"] = "h3";
    HeadingLevel["H4"] = "h4";
    HeadingLevel["H5"] = "h5";
    HeadingLevel["H6"] = "h6";
})(HeadingLevel || (HeadingLevel = {}));
export const Heading = observer(props => {
    const { level: Level, children } = props, other = __rest(props, ["level", "children"]);
    return _jsx(Level, Object.assign({}, other, { children: children }));
});
Heading.displayName = 'Heading';
